<template>
    <div>
        <div class="modal fade" id="add-form-modal" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                        <h4 class="modal-title">ADD NEW FORM</h4>
                    </div>
                    <div class="modal-body">
                        <form data-vv-scope="new-form-modal">

                            <div class="form-group" :class="{ 'has-error': errors.has('new-form-modal.Form Name') }">
                                <label for="fb-formname">Form Name</label>
                                <input id="fb-formname" class="form-control" name="Form Name" type="text"
                                       v-validate="'required'" v-model="newFormName">
                                <span v-show="errors.has('new-form-modal.Form Name')" class="help-block">{{ errors.first('new-form-modal.Form Name') }}</span>
                            </div>

                            <div class="form-group" :class="{ 'has-error': errors.has('new-form-modal.Description') }">
                                <label for="fb-formdesc">Form Description</label>
                                <textarea id="fb-formdesc" class="form-control" name="Description" type="text"
                                          v-validate="'required'" v-model="newFormDesc"></textarea>
                                <span v-show="errors.has('new-form-modal.Description')" class="help-block">{{ errors.first('new-form-modal.Description') }}</span>
                            </div>

                            <div class="form-group">
                                <label>Create From Template</label>
                                <select class="form-control" name="Template" v-model="createFromTemplate">
                                    <option :value="null"></option>
                                    <option v-for="template in templates" :value="template.id">{{template.name}}
                                    </option>
                                </select>
                            </div>

                            <div class="form-group" v-if="newFormType == 'form' && !(modules.length === 1 && preselectedModule !== undefined)"
                                 :class="{ 'has-error': errors.has('new-form-modal.Related') }"
                            >
                                <label>Related to</label>
                                <select class="form-control" v-model="newFormModule" name="Related"
                                        v-validate="'required'" :disabled="this.lockModuleSelect">
                                    <option v-for="module in modules" :value="module.key">{{ module.name }}</option>
                                </select>
                                <span v-show="errors.has('new-form-modal.Related')" class="help-block">{{ errors.first('new-form-modal.Related') }}</span>
                            </div>

                            <div class="form-group" v-if="userAccessLevels"
                                 :class="{ 'has-error': errors.has('new-form-modal.User Access') }">
                                <label>User access</label>
                                <select class="form-control" v-model="newFormAccessLevel" name="User Access"
                                        v-validate="'required'">
                                    <option v-for="accessLevel in userAccessLevels" :value="accessLevel.key">{{
                                        accessLevel.name }}
                                    </option>
                                </select>
                                <span v-show="errors.has('new-form-modal.User Access')" class="help-block">{{ errors.first('new-form-modal.User Access') }}</span>
                            </div>

                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn green mt-ladda-btn ladda-button add-form-btn" @click.prevent="addFormAction"
                                data-style="expand-left">
                            <span class="ladda-label">Add Form</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from "vuex";

    export default {
        props: ['modules', 'preselectedModule', 'userAccessLevels', 'lockModuleSelect', 'isTemplate'],
        data() {
            return {
                createFromTemplate: null,
                multipleEntries: true,
                newFormAccessLevel: null,
                newFormDesc: '',
                newFormModule: null,
                newFormName: '',
                newFormType: 'form',
                show: false,
            }
        },

        inject: {
            $validator: '$validator'
        },

        mounted() {

            if (this.preselectedModule) {
                this.newFormModule = this.preselectedModule;
            }

            if (this.isTemplate) {
                this.newFormType = 'template';
            } else {
                this.fetchFormsTemplates();
            }

            $('#add-form-modal').modal('show');
            $('#add-form-modal').on('hidden.bs.modal', () => {
                this.$emit('hide');
            });
        },

        computed: {
            ...mapGetters({
                appUser: 'getUser',
                creatingFailed: 'getCreatingFailed',
                duplicatingFailed: 'getDuplicatingFailed',
                form: 'getLastCreatedForm',
                templates: 'getFormsTemplates'
            }),
        },

        methods: {
            ...mapActions([
                'createForm',
                'duplicateForm',
                'fetchFormsTemplates'
            ]),

            addFormAction() {
                this.$validator.validateAll('new-form-modal').then((result) => {
                    if (result) {
                        let params = {
                            name: this.newFormName,
                            data: '[]',
                            description: this.newFormDesc,
                            type: this.newFormType,
                            module: this.newFormModule,
                            access_level: this.newFormAccessLevel,
                            id: this.createFromTemplate
                        };

                        this.btn = Ladda.create(document.querySelector('.add-form-btn'));
                        this.btn.start();

                        if(this.createFromTemplate) {
                            this.duplicateForm(params).then(() => {
                                this.btn.stop();
                                $('#add-form-modal').modal('hide');

                                if(!this.duplicatingFailed) {
                                    this.$router.push({name: 'Form Builder Edit', params: {id: this.form.id}});
                                }
                            });
                            return;
                        }

                        this.createForm(params).then(() => {
                            this.btn.stop();
                            $('#add-form-modal').modal('hide');

                            if(!this.creatingFailed) {
                                this.$router.push({name: 'Form Builder Edit', params: {id: this.form.id}});
                            }
                        });
                    }
                });
            },

        },
    }
</script>



// WEBPACK FOOTER //
// AddFormModal.vue?fa453330